export default "__VITE_ASSET__BUUrcmwh__"